"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const StratumnLogomark = ({ className, height, width }) => (jsx_runtime_1.jsx("svg", Object.assign({ height: height, width: width, className: className, version: "1.1", id: "Layer_1", x: "0px", y: "0px", viewBox: "0 0 14 18", xmlSpace: "preserve" }, { children: jsx_runtime_1.jsxs("g", { children: [jsx_runtime_1.jsx("path", { className: "st0", d: "M8.2,4.6H5.8L0,17.9h14L8.2,4.6z M3.9,15.5L7,8.1l3.1,7.3H3.9z" }, void 0),
            jsx_runtime_1.jsx("rect", { x: "2.8", y: "0.1", className: "st0", width: "8.3", height: "2.5" }, void 0)] }, void 0) }), void 0));
StratumnLogomark.propTypes = {
    height: prop_types_1.default.number,
    width: prop_types_1.default.number,
    className: prop_types_1.default.string
};
StratumnLogomark.defaultProps = {
    height: 18,
    width: 14,
    className: ''
};
exports.default = StratumnLogomark;
//# sourceMappingURL=index.js.map